const Modal = Object.freeze({
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
});

export const Modals = {
  CONNECTION_ERROR: 'CONNECTION_ERROR',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  SETTINGS: 'SETTINGS',
  SESSION_CREATED: 'SESSION_CREATED',
  CONFIRM: 'CONFIRM',
  EDIT_SESSION: 'EDIT_SESSION',
  EDIT_ORGANIZATION: 'EDIT_ORGANIZATION',
  EDIT_USER: 'EDIT_USER',
  INFO: 'INFO',
  ERROR: 'ERROR',
};

export const openModal = (modalProps = {}, modalName) => {
  return {
    type: Modal.OPEN_MODAL,
    payload: modalProps,
    modalName,
  };
};

export const closeModal = () => {
  return {
    type: Modal.CLOSE_MODAL,
  };
};

const INIT_STATE = {
  showModal: false,
  modalProps: {},
  modalName: null,
};

export const uiReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case Modal.OPEN_MODAL: {
      return { ...state, showModal: true, modalProps: action.payload, modalName: action.modalName };
    }
    case Modal.CLOSE_MODAL: {
      return { ...state, showModal: false, modalName: null };
    }
    default:
      return state;
  }
};
